import {createReducer, on} from '@ngrx/store';
import {createEntityAdapter, EntityAdapter, EntityState} from '@ngrx/entity';
import {ApprovedService} from './approved-service.model';
import * as ApprovedServiceActions from './approved-service.actions';

export const approvedServicesFeatureKey = 'approvedServices';

export interface State extends EntityState<ApprovedService> {
  // additional entities state properties
}

export const adapter: EntityAdapter<ApprovedService> = createEntityAdapter<ApprovedService>();

export const initialState: State = adapter.getInitialState({
  // additional entity state properties
});

export const reducer = createReducer(
  initialState,
  on(ApprovedServiceActions.addApprovedService,
    (state, action) => adapter.addOne(action.approvedService, state)
  ),
  on(ApprovedServiceActions.upsertApprovedService,
    (state, action) => adapter.upsertOne(action.approvedService, state)
  ),
  on(ApprovedServiceActions.addApprovedServices,
    (state, action) => adapter.addMany(action.approvedServices, state)
  ),
  on(ApprovedServiceActions.upsertApprovedServices,
    (state, action) => adapter.upsertMany(action.approvedServices, state)
  ),
  on(ApprovedServiceActions.updateApprovedService,
    (state, action) => adapter.updateOne(action.approvedService, state)
  ),
  on(ApprovedServiceActions.updateApprovedServices,
    (state, action) => adapter.updateMany(action.approvedServices, state)
  ),
  on(ApprovedServiceActions.deleteApprovedService,
    (state, action) => adapter.removeOne(action.id, state)
  ),
  on(ApprovedServiceActions.deleteApprovedServices,
    (state, action) => adapter.removeMany(action.ids, state)
  ),
  on(ApprovedServiceActions.loadApprovedServices,
    (state, action) => adapter.setAll(action.approvedServices, state)
  ),
  on(ApprovedServiceActions.clearApprovedServices,
    state => adapter.removeAll(state)
  ),
);

export const {
  selectIds,
  selectEntities,
  selectAll,
  selectTotal,
} = adapter.getSelectors();
